import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["__scopeDialog"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { DESCRIPTION_NAME } from './constants';
import { useDialogContext } from './context';
import { DomPrimitive } from '../../internal/components/DomPrimitive';
import { jsx as _jsx } from "react/jsx-runtime";
export const DialogDescription = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const {
      __scopeDialog
    } = props,
    descriptionProps = _objectWithoutProperties(props, _excluded);
  const context = useDialogContext(DESCRIPTION_NAME, __scopeDialog);
  return /*#__PURE__*/_jsx(DomPrimitive.p, _objectSpread(_objectSpread({
    id: context.descriptionId
  }, descriptionProps), {}, {
    ref: forwardedRef
  }));
});
DialogDescription.displayName = DESCRIPTION_NAME;